/* eslint-disable max-len */
import { types as coreTypes } from '@sitebuilder/core';

const schema = (props: any): coreTypes.Schema => {
    const _schema: any = {
        columns: {
            type: 'array',
            title: 'Add columns',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string', title: 'Enter column id' },
                    label: { type: 'string', title: 'Enter column header' },
                    labelDescription: { type: 'string', title: 'Enter additional description' },
                    type: {
                        type: 'string',
                        title: 'Select type for column value',
                        enum: ['', 'Text value', 'Placeholder', 'Watchlist', 'Selection'],
                    },
                    isSortable: {
                        type: 'boolean',
                        title: 'Enable Sorting',
                        enum: [true, false],
                    },
                    isIncludeInDownloadFile: {
                        type: 'boolean',
                        title: 'Is include in download file',
                    },
                    columnGrouping: {
                        type: 'string',
                        title: 'Id of column group',
                    },
                },
                dependencies: {
                    type: {
                        oneOf: [
                            {
                                properties: {
                                    type: { enum: ['Text value'] },
                                    value: {
                                        type: 'string',
                                        title: 'Enter value data key',
                                    },
                                },
                            },
                            {
                                properties: {
                                    type: { enum: ['Placeholder'] },
                                    placeholderId: {
                                        type: 'string',
                                        title: 'Enter placeholder Id',
                                        description: 'Unique placeholder id for placeholder',
                                    },
                                },
                                required: ['placeholderId'],
                            },
                            {
                                properties: {
                                    type: { enum: ['Watchlist'] },
                                    value: {
                                        type: 'string',
                                        title: 'Enter value data key',
                                    },
                                    watchlistType: {
                                        type: 'string',
                                        title: 'Watchlist Type',
                                        enum: ['icon', 'checkbox'],
                                        default: 'icon',
                                    },
                                    excludeWatchListOpt: {
                                        type: 'string',
                                        title: 'Choose option to hide watch list',
                                        enum: [
                                            '',
                                            'Individual Fund Ids',
                                            'Data key for Fund Ids',
                                            'Data key for condition',
                                        ],
                                        description: '',
                                    },
                                },
                                dependencies: {
                                    watchlistType: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    watchlistType: { enum: ['icon'] },
                                                    watchlistIconName: {
                                                        type: 'string',
                                                        title: 'watchlist Icon Name',
                                                        default: 'far fa-star',
                                                    },
                                                    selectedWatchlistIconName: {
                                                        type: 'string',
                                                        title: 'Selected watchlist Icon Name',
                                                        default: 'fas fa-star',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    watchlistType: { enum: ['checkbox'] },
                                                },
                                            },
                                        ],
                                    },
                                    excludeWatchListOpt: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    excludeWatchListOpt: {
                                                        enum: ['Individual Fund Ids'],
                                                    },
                                                    excludeWatchListFundIds: {
                                                        type: 'string',
                                                        title: 'Enter exclude watch list Fund Ids',
                                                        description:
                                                            'Enter fund Ids separated by comma',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    excludeWatchListOpt: {
                                                        enum: ['Data key for Fund Ids'],
                                                    },
                                                    excludeWatchListFundIdsDataKey: {
                                                        type: 'string',
                                                        title: 'Enter data key for fund Ids in data to exclude from watch list',
                                                        description: 'Enter JSON data key',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    excludeWatchListOpt: {
                                                        enum: ['Data key for condition'],
                                                    },
                                                    excludeWatchListConditionDataKey: {
                                                        type: 'string',
                                                        title: `Enter data key for condition for exclude watch list based on`,
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    excludeWatchListOpt: { enum: [''] },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            {
                                properties: {
                                    type: { enum: ['Selection'] },
                                    selectionListId: {
                                        type: 'string',
                                        title: 'Enter property Id',
                                        description:
                                            // eslint-disable-next-line max-len
                                            `This property will be used as id when adding items to selection list
                                             Note: add url for booklet download `,
                                    },
                                    selectionUsedFor: {
                                        type: 'string',
                                        enum: ['compare', 'downloadBooklet'],
                                        title: 'Selection Used For',
                                        default: 'compare',
                                    },
                                    selectionListStorageName: {
                                        type: 'string',
                                        description:
                                            'Selection list storage item name. Note: for download booklet this will be used for local state only not for storage',
                                        title: 'Storage Name',
                                        default: 'compare',
                                    },
                                    addToSelectionlistText: {
                                        type: 'string',
                                        title: 'Add to selectionlist text',
                                    },
                                    removeFromSelectionlistText: {
                                        type: 'string',
                                        title: 'Remove from selectionlist text',
                                    },
                                    ActiveButtonText: {
                                        type: 'string',
                                        title: 'Active button text',
                                    },
                                    minSelectionCount: {
                                        type: 'number',
                                        title: 'Minimum limit for selection',
                                        default: 2,
                                    },
                                    maxSelectionCount: {
                                        type: 'number',
                                        title: 'Maximum limit for selection',
                                    },
                                },
                                required: ['selectionListStorageName', 'selectionListId'],
                                dependencies: {
                                    selectionUsedFor: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    selectionUsedFor: { enum: ['compare'] },
                                                    changeToTab: {
                                                        type: 'string',
                                                        title: 'Enter tab id',
                                                        description:
                                                            // eslint-disable-next-line max-len
                                                            'Id of the tab to change upon clicking on compare',
                                                    },
                                                    excludeCompareOpt: {
                                                        type: 'string',
                                                        title: 'Choose option to exclude fund Ids for compare',
                                                        enum: [
                                                            '',
                                                            'Individual Fund Ids',
                                                            'Data key for Fund Ids',
                                                            'Data key for condition',
                                                        ],
                                                        description: '',
                                                    },
                                                },
                                                dependencies: {
                                                    excludeCompareOpt: {
                                                        oneOf: [
                                                            {
                                                                properties: {
                                                                    excludeCompareOpt: {
                                                                        enum: [
                                                                            'Individual Fund Ids',
                                                                        ],
                                                                    },
                                                                    excludeCompareFundIds: {
                                                                        type: 'string',
                                                                        title: 'Enter exclude compare fund Ids',
                                                                        description:
                                                                            'Enter fund Ids separated by comma',
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                properties: {
                                                                    excludeCompareOpt: {
                                                                        enum: [
                                                                            'Data key for Fund Ids',
                                                                        ],
                                                                    },
                                                                    excludeCompareFundIdsDataKey: {
                                                                        type: 'string',
                                                                        title: 'Enter data key for fund Ids in data to exclude from compare',
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                properties: {
                                                                    excludeCompareOpt: {
                                                                        enum: [
                                                                            'Data key for condition',
                                                                        ],
                                                                    },
                                                                    excludeCompareConditionDataKey:
                                                                        {
                                                                            type: 'string',
                                                                            title: `Enter data key for condition for exclude compare based on `,
                                                                        },
                                                                },
                                                            },
                                                            {
                                                                properties: {
                                                                    excludeCompareOpt: {
                                                                        enum: [''],
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    selectionUsedFor: { enum: ['downloadBooklet'] },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        ],
                    },
                    isIncludeInDownloadFile: {
                        oneOf: [
                            {
                                properties: {
                                    isIncludeInDownloadFile: { enum: [true] },
                                    downloadHeaderValue: {
                                        type: 'string',
                                        title: 'Download header value',
                                        description: `Optional: provide a value if its
                                            different from web column header value`,
                                    },
                                    downloadDataValue: {
                                        type: 'string',
                                        title: 'Download data value',
                                        description: `Optional: provide a value if its
                                            different from web column data value`,
                                    },
                                },
                            },
                            {
                                properties: {
                                    isIncludeInDownloadFile: { enum: [false] },
                                },
                            },
                        ],
                    },
                    isSortable: {
                        oneOf: [
                            {
                                properties: {
                                    isSortable: { enum: [true] },
                                    sortId: {
                                        type: 'string',
                                        title: 'Sort Id',
                                        description: 'data id for sorting',
                                    },
                                    iconPosition: {
                                        type: 'string',
                                        title: 'Icon position',
                                        enum: ['Right', 'Left'],
                                        default: 'Right',
                                    },
                                    iconType: {
                                        type: 'string',
                                        title: 'Sort Icon type',
                                        enum: ['', 'FontAwesome icon', 'Image'],
                                    },
                                    sortAnalyticLabel: {
                                        type: 'string',
                                        title: 'Sort Analytic label',
                                        description: 'Analytic label for sorting',
                                    },
                                },
                                dependencies: {
                                    iconType: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    iconType: { enum: ['FontAwesome icon'] },
                                                    iconSort: {
                                                        type: 'string',
                                                        title: 'Enter value for sort icon',
                                                        default: 'fa-sort',
                                                    },
                                                    iconUp: {
                                                        type: 'string',
                                                        title: 'Enter value for sort up icon',
                                                        default: 'fa-sort-up',
                                                    },
                                                    iconDown: {
                                                        type: 'string',
                                                        title: 'Enter value for sort down icon',
                                                        default: 'fa-sort-down',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    iconType: { enum: ['Image'] },
                                                    imageSort: {
                                                        type: 'string',
                                                        title: 'Enter url for sort image',
                                                    },
                                                    imageUp: {
                                                        type: 'string',
                                                        title: 'Enter url for sort up image',
                                                    },
                                                    imageDown: {
                                                        type: 'string',
                                                        title: 'Enter url for sort down image',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            {
                                properties: {
                                    isSortable: { enum: [false] },
                                },
                            },
                        ],
                    },
                },
            },
        },
    };

    if (props.enableColumnToggling) {
        _schema.columns.items.properties.disableVisibilityToggle = {
            type: 'boolean',
            title: 'Disable visibility toggle',
        };
    } else {
        delete _schema.columns.items.properties.disableVisibilityToggle;
    }

    return _schema;
};

const uiSchema = {
    columns: {
        items: {
            'ui:field': 'CollapsibleFieldTemplate',
            'ui:order': [
                'id',
                'label',
                'labelDescription',
                'columnGrouping',
                'type',
                'value',
                'placeholderId',
                'watchlistType',
                'watchlistIconName',
                'selectedWatchlistIconName',
                'excludeWatchListOpt',
                'excludeWatchListFundIds',
                'excludeWatchListFundIdsDataKey',
                'excludeWatchListConditionDataKey',
                'selectionListId',
                'selectionUsedFor',
                'changeToTab',
                'excludeCompareOpt',
                'excludeCompareFundIds',
                'excludeCompareFundIdsDataKey',
                'excludeCompareConditionDataKey',
                'selectionListStorageName',
                'addToSelectionlistText',
                'removeFromSelectionlistText',
                'maxSelectionCount',
                'minSelectionCount',
                'ActiveButtonText',
                'isIncludeInDownloadFile',
                'downloadDataValue',
                'downloadHeaderValue',
                'isSortable',
                'sortId',
                'iconPosition',
                'iconType',
                'iconSort',
                'sortAnalyticLabel',
                'iconUp',
                'iconDown',
                'imageSort',
                'imageUp',
                'imageDown',
                'disableVisibilityToggle',
                '*',
            ],
            id: { 'ui:widget': 'CustomTextInput' },
            label: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            labelDescription: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            type: { 'ui:widget': 'CustomSelect' },
            isSortable: { 'ui:widget': 'CustomCheckbox' },
            isIncludeInDownloadFile: { 'ui:widget': 'CustomCheckbox' },
            disableVisibilityToggle: { 'ui:widget': 'CustomCheckbox' },
            value: { 'ui:widget': 'CustomTextInput', 'ui:placeholder': '{{ }}' },
            downloadDataValue: { 'ui:widget': 'CustomTextInput', 'ui:placeholder': '{{ }}' },
            downloadHeaderValue: { 'ui:widget': 'CustomTextInput', 'ui:placeholder': '{{ }}' },
            placeholderId: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            sortId: { 'ui:widget': 'CustomTextInput' },
            iconPosition: { 'ui:widget': 'CustomSelect' },
            iconType: { 'ui:widget': 'CustomSelect' },
            iconSort: { 'ui:widget': 'CustomTextInput' },
            sortAnalyticLabel: { 'ui:widget': 'CustomTextInput' },
            iconUp: { 'ui:widget': 'CustomTextInput' },
            iconDown: { 'ui:widget': 'CustomTextInput' },
            imageSort: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            imageUp: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            imageDown: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            watchlistType: { 'ui:widget': 'CustomSelect' },
            columnGrouping: { 'ui:widget': 'CustomTextInput' },
            selectedWatchlistIconName: { 'ui:widget': 'CustomTextInput' },
            watchlistIconName: { 'ui:widget': 'CustomTextInput' },
            selectionListId: { 'ui:widget': 'CustomTextInput' },
            selectionUsedFor: { 'ui:widget': 'CustomSelect' },
            selectionListStorageName: { 'ui:widget': 'CustomTextInput' },
            addToSelectionlistText: { 'ui:widget': 'ResourcePicker' },
            removeFromSelectionlistText: { 'ui:widget': 'ResourcePicker' },
            maxSelectionCount: { 'ui:widget': 'CustomTextInput' },
            minSelectionCount: { 'ui:widget': 'CustomTextInput' },
            ActiveButtonText: { 'ui:widget': 'ResourcePicker' },
            compareButtonText: { 'ui:widget': 'ResourcePicker' },
            excludeWatchListOpt: { 'ui:widget': 'CustomSelect' },
            excludeWatchListFundIds: { 'ui:widget': 'CustomTextInput' },
            excludeWatchListFundIdsDataKey: { 'ui:widget': 'CustomTextInput' },
            excludeWatchListConditionDataKey: {
                'ui:widget': 'ResourcePicker',
                'ui:placeholder': '{{ }}',
            },
            excludeCompareOpt: { 'ui:widget': 'CustomSelect' },
            excludeCompareFundIds: { 'ui:widget': 'CustomTextInput' },
            excludeCompareFundIdsDataKey: { 'ui:widget': 'CustomTextInput' },
            excludeCompareConditionDataKey: {
                'ui:widget': 'CustomTextInput',
                'ui:placeholder': '{{ }}',
            },
        },
    },
};

const columnSchema = {
    schema,
    uiSchema,
};

export default columnSchema;
